import { expVal } from '@atlassian/jira-feature-experiments';

const FrontierGuidedAutonomyEapRelayProvider = {
	get(): boolean {
		return expVal('frontier-guided-autonomy-eap', 'isEnabled', false);
	},
};

export default FrontierGuidedAutonomyEapRelayProvider;
